module.exports = __webpack_public_path__ + "img/bank_transfer.dfe802c.svg";